import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NGXLogger as LoggerService } from 'ngx-logger';
import { AuthService } from './auth.service';
import { UIMesageService } from '../shared/services/ui-message.service';
import { TranslationGeneralService } from '../shared/translation/translation.general.service';
import { environment } from '../../environments/environment';

/**
 * Schuetzt Admin-only Routes (z.B. /admin und Sample-Poll-Verwaltung).
 * Admin wird ueber environment.adminUids (Firebase-UID-Whitelist) definiert.
 * Nicht-Admins werden auf /user/no-access umgeleitet; Nicht-eingeloggte auf /user/login.
 */
@Injectable({
    providedIn: 'root',
})
export class AdminGuard {
    constructor(
        private authService: AuthService,
        private logger: LoggerService,
        private router: Router,
        private uiMessage: UIMesageService,
        private trans: TranslationGeneralService
    ) { }

    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        this.logger.log('AdminGuard.canActivate', next.data?.id);
        const isLoggedIn = await this.authService.getIsLoggedIn();
        if (!isLoggedIn) {
            this.logger.log('AdminGuard: not logged in');
            this.authService.navigateToUrl = state.url;
            return this.router.parseUrl('user/login');
        }
        const uid = this.authService.uid;
        const adminUids: string[] = environment.adminUids || [];
        if (!uid || !adminUids.includes(uid)) {
            this.logger.warn('AdminGuard: uid not in adminUids', uid);
            this.uiMessage.warning(this.trans.translate('noAccess'));
            return this.router.parseUrl('user/no-access');
        }
        return true;
    }

    /**
     * Synchroner Check fuer Komponenten/Templates (z.B. um Admin-only Bereiche
     * zu verbergen). Setzt voraus dass der Auth-State bereits initialisiert ist.
     */
    public isAdmin(): boolean {
        const uid = this.authService.uid;
        const adminUids: string[] = environment.adminUids || [];
        return !!uid && adminUids.includes(uid);
    }
}
